import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import ApiServices from "../../../Services/ApiServices/ApiServices";

const ReferalSourcesEdit = ({ data, onClose, onSuccess }) => {
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (data) setForm(data);
  }, [data]);

  if (!form) return null;

  const handleChange = (field, value) => {
    if (field.startsWith("bank_")) {
      setForm({
        ...form,
        bank_details: {
          ...form.bank_details,
          [field.replace("bank_", "")]: value,
        },
      });
    } else {
      setForm({ ...form, [field]: value });
    }
  };

  const handleUpdate = async () => {
    try {
      await ApiServices.put(
        `referral-sources/${form.id}/`,
        form
      );
      onSuccess("Referral source updated successfully");
    } catch {
      onSuccess("Failed to update referral source", "error");
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {[
          "name",
          "email",
          "phone",
          "address",
          "zip_code",
          "company",
          "department",
          "position",
          "password",
        ].map((f) => (
          <Grid item xs={12} md={6} key={f}>
            <TextField
              fullWidth
              label={f.replace("_", " ").toUpperCase()}
              value={form[f] || ""}
              onChange={(e) => handleChange(f, e.target.value)}
            />
          </Grid>
        ))}

        {["account_number", "routing_number", "bank_name"].map((f) => (
          <Grid item xs={12} md={6} key={f}>
            <TextField
              fullWidth
              label={f.replace("_", " ").toUpperCase()}
              value={form.bank_details?.[f] || ""}
              onChange={(e) =>
                handleChange(`bank_${f}`, e.target.value)
              }
            />
          </Grid>
        ))}
      </Grid>

      <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" onClick={handleUpdate}>
          Update
        </Button>
      </Box>
    </Box>
  );
};

export default ReferalSourcesEdit;
